import gql from 'graphql-tag';

export const GET_DELIVERY_ACTUALS_LIST = gql`
    query($member_no: Int!, $limit: Int!, $offset: Int!){
        getDeliveryActualsList(member_no: $member_no, limit: $limit, offset: $offset){
            DeliveryActualsList {
                delivery_id
                delivery_date
                member_no
                reserve_no
                delivery_type
                delivery_contents
                valid_flag
            }
            totalCount
        }
    }
`;

